import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function SignOut() {
  const { instance, inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const logoutUser = async () => {
      try {
        // Only proceed if not already in an interaction (prevents infinite loops)
        if (
          inProgress !== InteractionStatus.Startup &&
          inProgress !== InteractionStatus.HandleRedirect
        ) {
          // Clear local storage (remove stored role)
          localStorage.removeItem("selectedRole");

          // Sign out from Azure AD B2C
          await instance.logoutRedirect({
            postLogoutRedirectUri: "/authentication/sign-in",
          });
        }
      } catch (error) {
        console.error("Logout Error:", error);
      }
    };

    logoutUser();
  }, [instance, navigate, inProgress]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <CircularProgress />
      <Typography variant="h6" mt={2}>
        Signing out...
      </Typography>
    </Box>
  );
}
